import React, {useState} from 'react';
import PropTypes from 'prop-types'
import {makeStyles} from '@material-ui/core';
import ReactCardFlip from "react-card-flip";
import Typography from "@material-ui/core/Typography";
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const useStyles = makeStyles(theme => ({
    firstPageContainer: {
        textAlign: 'center',
        "&:hover": {cursor: 'pointer'},
        height: 430,
        borderRadius: 20,
        [theme.breakpoints.only('xs')]: {
            width: 250,
        },
        [theme.breakpoints.only('sm')]: {
            width: 300,
            height: 430
        }
    },
    firstPageImage: {
        maxWidth: 250,
        maxHeight: 126,
        marginTop: 50
    },
    barH: {
        border: '1px solid #94C11F',
        flexGrow: 1,
        margin: '0px 20px',
        marginTop: '65px',
        marginBottom: '25px',
    },
    firstPageTitle: {
        textTransform: 'uppercase',
        color: '#707070',
        fontSize: 18,
        fontWeight: 'bold',
        lineHeight: '31px',
        [theme.breakpoints.down('sm')]: {
            fontSize: 18,
            lineHeight: '23px',
        }
    },
    secondPageContainer: {
        "&:hover": {cursor: 'pointer'},
        backgroundColor: "#94C11F",
        height: 430,
        borderRadius: 20,
        [theme.breakpoints.only('xs')]: {
            width: 250
        },
        [theme.breakpoints.only('sm')]: {
            width: 300
        }
    },
    optionContainer: {
        display: 'flex',
        margin: '10px 0px',
        alignItems: 'center'
    },
    optionsContainer: {
        justifyContent: 'space-between',
        display: 'flex',
        flexDirection: 'column',
        height: 360,
        padding: 20,
    },
    optionImage: {
        width: 30,
        [theme.breakpoints.only('xs')]: {
            width: 20,
        },
        [theme.breakpoints.only('sm')]: {
            width: 25,
        }
    },
    barV: {
        border: '1px solid #fff',
        width: 58,
        transform: 'rotate(90deg)'
    },
    optionText: {
        color: '#fff',
        fontSize: 18,
        fontWeight: '500',
        lineHeight: '27px',
        width: 230,
        [theme.breakpoints.only('xs')]: {
            fontSize: 12,
            lineHeight: '20px',
        },
        [theme.breakpoints.only('sm')]: {
            fontSize: 15,
            lineHeight: '20px',
        }
    },
    optionDesc: {
        color: '#fff',
        fontSize: 18,
        fontWeight: '500',
        lineHeight: '25px',
        [theme.breakpoints.only('xs')]: {
            fontSize: 12,
            lineHeight: '20px',
        },
        [theme.breakpoints.only('sm')]: {
            fontSize: 15,
            lineHeight: '20px',
        }
    }
}));

function FlipComponent({img, title, logos, options}) {
    const classes = useStyles();
    const [isFlipped, setIsFlipped] = useState(false);
    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.only('sm'));
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));

    const onClick = () => setIsFlipped(!isFlipped);

    return (
        <ReactCardFlip isFlipped={isFlipped}
                       flipDirection="horizontal"
                       containerStyle={{
                           boxShadow: '3px 3px 20px #00000029',
                           height: 430,
                           borderRadius: 20,
                           marginLeft: 'auto',
                           marginRight: 'auto',
                           width: isSm ? 300 : isXs ? 250 : 277
                       }}
        >
            <div className={classes.firstPageContainer} onClick={onClick}>
                <img src={img} alt="Icon" className={classes.firstPageImage}/>
                <div className={classes.barH}/>
                <Typography className={classes.firstPageTitle}>
                    {title}
                </Typography>
            </div>

            <div className={classes.secondPageContainer} onClick={onClick}>
                <div className={classes.optionsContainer}>
                    {
                        options.map((item, index) => <div className={classes.optionContainer} key={index}>
                            {
                                logos[index] ? <>
                                    <img src={logos[index]} alt={"Icon"} className={classes.optionImage}/>
                                    <div className={classes.barV}/>
                                    <Typography className={classes.optionText}>
                                        {item}
                                    </Typography>
                                </> : <>
                                <Typography className={classes.optionDesc}>
                                    {
                                        item.split(';').map((item, index) => {
                                            return <React.Fragment key={index}>
                                                    {item}
                                                <br/>
                                            </React.Fragment>
                                        })
                                    }
                                </Typography>
                                </>
                            }

                        </div>)
                    }
                </div>
            </div>
        </ReactCardFlip>
    )
}

FlipComponent.propTypes = {
    img: PropTypes.string.isRequired,
    flip: PropTypes.bool,
    title: PropTypes.object.isRequired,
    logos: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
    options: PropTypes.array.isRequired,
};

export default FlipComponent